export default class RegisterExecutionCtrl {

	constructor ($scope, $mdDialog, ReviewSrv, WorkPlanModalSrv, $state, $cookies, WorkPlanSrv, $stateParams, ngNotify,
		Validations, Ramda, FileUploader, SERVICE_URL_CONSTANT, $rootScope, GlobalConfig, GlobalSrv) {
		$scope.showForm = true
		const { curry } = Ramda
		const activity = WorkPlanModalSrv.getVariable()
		const currentModule = $state.current.module
		const userId = JSON.parse($cookies.get('currentUser')).id
		const finishedState = 'Finalizado'

		$('#register').attr('disabled', true)
		$scope.regUpdate = regUpdate
		$scope.upCompare = upCompare
		$rootScope.setHandsProgress = false

		const { isDoctoralEducationType, isTeacherDevelopmentType } = Validations

		const requireState = (activity) => isDoctoralEducationType(activity) || isTeacherDevelopmentType(activity)

		angular.extend($scope, {
			observations           : '',
			hoursExecuted          : null,
			action                 : 'Registrar',
			startDate              : null,
			endDate                : null,
			minStartDate           : null,
			minEndDate             : null,
			states                 : [],
			inTeaching             : Validations.inTeaching(currentModule),
			inConsolidation        : Validations.inConsolidation(currentModule),
			inInvestigation        : Validations.inInvestigation(currentModule),
			inExtension            : Validations.inExtension(currentModule),
			inAcademicManagement   : Validations.inAcademicManagement(currentModule),
			isColaborationSpaceType: Validations.isColaborationSpaceType(activity.children),
			isProjectDesignType    : Validations.isProjectDesignType(activity.children),
			requireState           : requireState(activity.children),
			state                  : null,
			oldHoursExecuted       : 0,
			fileName               : null,
			attachFile             : '',
			loading                : false,
			min                    : 0,
			finishedState          : finishedState,
			errorMsg               : false,
			STATIC_IMAGE_URL       : false,
			isShowState            : null,
			close                  : close,
			register               : register,
			validateForm           : validateForm,
			showErrorMessages      : showErrorMessages,
			startDateChange        : startDateChange,
			disabledEndDate        : true,
			remove                 : remove,
			hasError               : hasError,
		})

		activate()

		function activate () {
			history(activity.children)
			getData()

			if (activity.children.itemRequired || activity.itemRequired > 0) { $scope.min = 1 }
			
			getStatesCombo()
		}

		function getData () {
			if (activity.action === 'EDIT') {
				$scope.action = 'Modificar'
				$scope.hoursExecuted = activity.children.hoursExecuted
				$scope.observations = activity.children.descriptionExecution
				$scope.oldHoursExecuted = activity.children.hoursExecuted
				$scope.startDate = moment(activity.children.startDate, 'DD/MM/YYYY').toDate()
				$scope.endDate = moment(activity.children.endDate, 'DD/MM/YYYY').toDate()
				startDateChange($scope.startDate, 'start')
				$scope.state = activity.children.status
				$scope.fileName = activity.children.fileName
				$scope.isShowState = activity.isShowState

				if ($scope.fileName != null && $scope.fileName != '') {
					var miArray = $scope.fileName.split('/', -1)

					$scope.attachFile = miArray[miArray.length - 1]
				}

				if ($scope.startDate == 'Invalid Date' || activity.children.startDate == 'Invalid date') {
					$scope.startDate = null
				}

				if ($scope.endDate == 'Invalid Date' || activity.children.endDate == 'Invalid date') {
					$scope.endDate = null
				}
			}
		}

		function regUpdate (reg, i) {
			if ($scope.arrayvar[i].num_hours_executed != reg.num_hours_executed) {
				$scope.diff = reg.num_hours_executed - $scope.arrayvar[i].num_hours_executed
			} else {
				$scope.diff = 0
			}

			const params = {
				id_key            : activity.children.workplanTeacherActivityId,
				hourdiff          : $scope.diff,
				id_code           : reg.id_code,
				num_hours_executed: reg.num_hours_executed,
				ds_description    : reg.ds_description,
			}

			WorkPlanSrv.postUptHistoryActivities.get(params).$promise.then((response) => {
				if (!response.status) {
					ngNotify.set('Error al conectar con el servicio', 'error')
				} else {
					activity.children.hoursExecuted += $scope.diff
					ngNotify.set('Bitacora Actualizada', 'success')
					$scope.close()
				}
			}, (err) => {
				ngNotify.set('Imposible conectar con el servicio', 'error')
			})
		}

		function getStatesCombo () {
			WorkPlanSrv.getListState.get().$promise.then(function (dataReturn) {
				if (dataReturn.status) {
					$scope.states = dataReturn.listStates
					$scope.showForm = false
				} else {
					console.log('Comunications problem with the server')
				}
			}, function (data) {
				console.log(data)
			})
		}

		function setHeader (activity) {
			return {
				idActivity          : activity.workplanTeacherActivityId,
				descriptionExecution: $scope.observations,
				hoursExecuted       : $scope.hoursExecuted,
				idEntry             : activity.workplanTeacherEntriesId,
				startDate           : moment($scope.startDate).format('YYYY-MM-DD'),
				endDate             : moment($scope.endDate).format('YYYY-MM-DD'),
				state               : $scope.state,
				oldHoursExecuted    : $scope.oldHoursExecuted,
				fileName            : $scope.fileName,
				attachFile          : $scope.attachFile,
				fileUrl             : $scope.fileUrl,
			}
		}

		function close () {
			return $mdDialog.hide()
		}

		function history (activity) {
			const params = {
				id: activity.workplanTeacherActivityId,
			}

			WorkPlanSrv.getHistoryActivities.get(params).$promise.then((response) => {
				if (!response.status) {
					ngNotify.set('Error al conectar con el servicio', 'error')
				} else {
					$scope.showForm = false
					$scope.variable = response.data
					$scope.arrayvar = angular.copy(response.data)
				}
			}, () => {
				ngNotify.set('Imposible conectar con el servicio', 'error')
			})
		}

		function upCompare (reg, i) {
			return $scope.arrayvar[i].ds_description != reg.ds_description || $scope.arrayvar[i].num_hours_executed != reg.num_hours_executed
		}

		function setDate (date) {
			return moment(date).format('DD/MM/YYYY')
		}

		function setData (activity, insertId, date, action) {
			return {
				idActivity               : activity.workplanTeacherActivityId,
				idActivity2              : activity.children.workplanTeacherActivityId,
				workplanTeacherActivityId: activity.children.workplanTeacherActivityId,
				descriptionExecution     : $scope.observations,
				hoursExecuted            : $scope.hoursExecuted,
				workplanTeacherEntriesId : insertId,
				dateCreation             : date,
				startDate                : setDate($scope.startDate),
				endDate                  : setDate($scope.endDate),
				status                   : $scope.state,
				action                   : action,
				fileName                 : $scope.fileName,
				attachFile               : $scope.attachFile,
				fileUrl                  : $scope.fileUrl,
			}
		}

		const addExecution = curry((activity, header) => {
			ReviewSrv.setExecution.post(header).$promise.then((dataReturn) => {
				if (dataReturn.status) {
					let data = setData(activity, dataReturn.idActivityItem, moment(new Date()).format('DD/MM/YYYY'), 'ADD')

					WorkPlanModalSrv.setVariable(data)
					$rootScope.setHandsProgress = false
					$scope.close()
				}
			})
		})(activity)

		const editExecution = curry((activity, header) => {
			ReviewSrv.editExecution.post(header).$promise.then((dataReturn) => {
				if (dataReturn.status) {
					let data = setData(activity, header.idEntry, moment(new Date()).format('DD/MM/YYYY'), 'EDIT')

					WorkPlanModalSrv.setVariable(data)
					$rootScope.setHandsProgress = false
					$scope.close()
				}
			})
		})(activity)

		function getNotify (idRole, modulo, typecall, origin, nameuser, nameactivity) {
			const reviewers = GlobalSrv.getReviewerbySubmodule(idRole, GlobalConfig.modules.execution)

			if (reviewers) {
				getSendNotify(reviewers, modulo, typecall, origin, nameuser, nameactivity)
			}
		}

		function getSendNotify (idUser, modulo, typecall, origin, nameuser, nameactivity) {
			let msg

			if (Validations.inConsolidation(modulo) && typecall) {
				msg = 'El profesor ' + nameuser + ' ha efectuado cambios en sus actividades en seguimiento estratégico'
			}

			if (Validations.inConsolidation(modulo) && typecall) {
				GlobalSrv.sendNotification({
					idUser                      : idUser,
					dsName                      : 'Notificación, El profesor ' + nameuser + ' ha modificado una actividad',
					dsDescription               : msg,
					idNotification_delivery_type: GlobalConfig.notificationType.inbox,
					is_grouped                  : 1,
				})
			}
		}

		function register () {
			$rootScope.setHandsProgress = true
			$('#register').attr('disabled', true)
			let nameusers = JSON.parse($cookies.get('currentUser')).dsFullname

			switch (activity.action) {

			case 'ADD':
				addExecution(setHeader(activity.children))
				getNotify(GlobalConfig.userRolesIds.reviewer, currentModule, false, activity.children.origin, nameusers, activity.children.activityTypeNameCombo)
				getNotify(GlobalConfig.userRolesIds.approver, currentModule, false, activity.children.origin, nameusers, activity.children.activityTypeNameCombo)
				break
			case 'EDIT':
				editExecution(setHeader(activity.children))
				getNotify(GlobalConfig.userRolesIds.reviewer, currentModule, true, activity.children.origin, nameusers, activity.children.activityTypeNameCombo)
				getNotify(GlobalConfig.userRolesIds.approver, currentModule, true, activity.children.origin, nameusers, activity.children.activityTypeNameCombo)
				break
			default:
				console.log('Not an available action')
				break
			
			}
		}

		function showErrorMessages (input) {
			if (input) {
				return input.$dirty || input.$touched
			} else {
				return false
			}
		}

		function hasError (input) {
			if (input.$invalid && (input.$dirty || input.$touched)) {
				return 'has-error'
			}
		}

		function validateForm (form) {
			if (form) {
				if ($scope.inConsolidation === true) {
					return !(form.$invalid === false)
				} else {
					return form.$invalid
				}
			}
		}

		function startDateChange (date, type) {
			switch (type) {

			case 'start':
				$scope.startDate = date
				break
			case 'end':
				$scope.endDate = date
				break
			
			}
			$scope.disabledEndDate = !$scope.startDate
			let m = moment($scope.startDate)

			$scope.minEndDate = m.isValid() ? m.add(0, 'days').toDate() : null
		}

		var uploader = $scope.uploader = new FileUploader({
			url: SERVICE_URL_CONSTANT.rosario + '/file/uploadFileExecution?userId=' + userId,
		})

		uploader.filters.push({
			name: 'syncFilter',
			fn  : function (item /* {File|FileLikeObject} */, options) {
				console.log('syncFilter')

				return this.queue.length < 10
			},
		})

		// an async filter
		uploader.filters.push({
			name: 'asyncFilter',
			fn  : function (item /* {File|FileLikeObject} */, options, deferred) {
				console.log('asyncFilter')
				setTimeout(deferred.resolve, 1e3)
			},
		})

		uploader.onSuccessItem = function (fileItem, response, status, headers) {
			if (response.status) {
				$scope.fileName = response.data
				$scope.fileUrl = response.url
				$scope.loading = false
				$scope.STATIC_IMAGE_URL = true
				$scope.attachFile = fileItem.file.name
				$scope.errorMsg = false
				$('#uploader').val('')
	  }
		}

		uploader.onErrorItem = function (fileItem, response, status, headers) {
			$scope.attachFile = ''
			$scope.STATIC_IMAGE_URL = false
			$scope.loading = false
			$scope.fileName = null
			$scope.errorMsg = true
			$('#uploader').val('')
		}

		uploader.onBeforeUploadItem = function (item) {
			const header = { userId: userId }
		
			item.formData.push(header)
			$scope.loading = true
		}

		function remove () {
			$scope.attachFile = ''
			$scope.STATIC_IMAGE_URL = false
			$scope.loading = false
			$scope.fileName = null
			$scope.errorMsg = false
			$('#uploader').val('')

			if (uploader.queue[0]) {
				uploader.queue[0].remove()
			}
		}
	}

}

RegisterExecutionCtrl.$inject = [ '$scope', '$mdDialog', 'ReviewSrv', 'WorkPlanModalSrv', '$state', '$cookies',
	'WorkPlanSrv', '$stateParams', 'ngNotify', 'Validations', 'Ramda', 'FileUploader', 'SERVICE_URL_CONSTANT', '$rootScope', 'GlobalConfig', 'GlobalSrv' ]



// WEBPACK FOOTER //
// ./src/app/u-faculty/workplan/partials/review/modals/registerExecutionCtrl.js